<template>
  <div class="main-body--content">
    <div class="main-body--left">
      <c-block-box
        title="1月核心业务指标概况"
        :sub-title="
          `${$cUtils.format.formatDate(new Date(), 'yyyy-MM-dd')} 更新`
        "
        class="margin-bottom-1rem"
      >
        <div class="table-item">
          <div class="table-head">
            <div class="head-item">核心指标</div>
            <div class="head-item">初始值</div>
            <div class="head-item">本月目标</div>
            <div class="head-item">当前值</div>
            <div class="head-item">当前成果</div>
          </div>
          <div class="table-body">
            <div
              class="table-line"
              v-for="(tableItem, index) in tableData"
              :key="index"
            >
              <div class="body-lable">{{ tableItem.name }}</div>
              <div class="body-lable">{{ tableItem.data1 }}</div>
              <div class="body-lable">{{ tableItem.data2 }}</div>
              <div class="body-lable">{{ tableItem.data3 }}</div>
              <div class="body-lable">{{ tableItem.data4 }}</div>
            </div>
          </div>
        </div>
        <div class="survey-tips">
          备注：初始值、目标于月初确定，当前值、当前成果每日更新
        </div>
      </c-block-box>
      <c-block-box title="核心业务指标增长趋势">
        <div style="height: 25.2rem;padding: 0 1.5rem">
          <ChartBarLine
            v-for="(item, index) in barLine"
            :key="index"
            :id="`iuiehege-${index}`"
            height="8.4rem"
            :name="item.name"
            :option="item.option"
          ></ChartBarLine>
        </div>
      </c-block-box>
    </div>
    <div class="main-body--right">
      <c-block-box title="核心业务指标增长趋势" class="margin-bottom-1rem">
        <div class="business-tags">
          <span>开发阶段</span>
          <span class="span1">验证阶段</span>
          <span class="span2">实施阶段</span>
        </div>
        <div class="business-box">
          <div
            class="business-line"
            v-for="(item, index) in projectLIst"
            :key="index"
          >
            <div class="business-lable">
              <span v-html="item.name.split('').join('<br />')"></span>
            </div>
            <div class="business-item">
              <template v-if="item.data">
                <div v-for="(data, key) in item.data" :key="`${index}-${key}`">
                  <div
                    :style="`width: ${data.width}%;margin-left:${data.left}%`"
                    :class="
                      `project-item project-item--${projectItem[
                        data.projectType
                      ] || 'verification'}`
                    "
                  >
                    <div class="line">
                      <span class="lable">项目名称：</span>
                      <span class="value">{{ data.projectName }}</span>
                      <span class="tags"
                        ><i class="icon"></i>{{ data.projectProgress }}</span
                      >
                    </div>
                    <div class="line">
                      <span class="lable">项目负责人：</span>
                      <span class="value">{{ data.projectLeader }}</span>
                      <span class="lable">总成本：</span>
                      <span class="value">{{ data.projectCost }}</span>
                    </div>
                    <!-- <div class="line">
                      <span class="lable1">项目开始时间：{{data.projectStartTime}}  项目结束时间：{{data.projectEndTime}}</span>
                    </div> -->
                    <div class="line">
                      <span class="lable">目标：</span>
                      <span class="value">{{ data.projectIndicatorsKey }}</span>
                      <span class="lable">成果：</span>
                      <span class="value">{{ data.projectResult }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="project-item--null" v-else></div>
            </div>
          </div>
        </div>
        <div class="pic-yAxis">
          <div class="pic-yAxis--box">
            <span class="upMonth">{{ timeData.data.up.month }}.01</span>
            <span class="curMonth" :style="`left: ${timeData.curPosition}%`"
              >{{ timeData.data.cur.month }}.{{ timeData.data.cur.onDay }}</span
            >
            <span class="downMonth"
              >{{ timeData.data.down.month }}.{{ timeData.data.down.day }}</span
            >
          </div>
        </div>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import ChartBarLine from '@/components/echarts/line'
export default {
  components: {
    ChartBarLine
  },
  props: {},
  data () {
    return {
      tableData: [],
      barLine: [],
      optionItem: {
        config: {
          xData: [
            '25-33岁',
            '两口小家',
            '硕士及以上',
            '白领',
            '孕期家庭',
            '有车一族',
            '观影偏好',
            '日收视时长',
            '观影时间偏好',
            '月消费'
          ],
          legendData: ['占比', 'TGI']
        },
        data: [
          {
            name: '占比',
            data: [10, 30, 20, 22, 10, 20, 26, 22, 10, 20, 26],
            lineStyle: {
              width: 3,
              type: 'dashed'
            },
            smooth: true
          },
          {
            name: 'TGI',
            data: [19, 22, 23, 24, 12, 22, 24, 18, 17, 20, 15],
            lineStyle: {
              width: 3,
              type: 'solid'
            },
            smooth: true
          }
        ]
      },
      timeData: {},
      projectItem: {
        1: 'verification',
        2: 'dev',
        3: 'success',
        4: 'fail'
      },
      projectLIst: []
    }
  },
  computed: {},
  methods: {
    getProject () {
      this.$service
        .fetch({
          url: 'api/business/growthTrend'
        })
        .then(res => {
          this.barLine = res.map(item => {
            const data = item.data
            const legendData = Object.keys(data)
            const option = {
              config: {
                xData: data[legendData[0]].date,
                legendData: legendData
              },
              data: []
            }
            const dataKeys = Object.keys(data)
            Object.values(data).map((rows, index) => {
              option.data.push({
                name: dataKeys[index],
                data: Object.values(rows)[1],
                lineStyle: {
                  width: 3,
                  type: index ? 'solid' : 'dashed'
                },
                smooth: true
              })
            })
            return {
              name: item.name,
              option: option
            }
          })
        })
      this.$service
        .fetch({
          url: 'api/business/dashboard'
        })
        .then(res => {
          this.tableData = res.tableData
          this.projectLIst = res.projects.map(list => {
            return {
              name: list.name,
              data: list.data
                ? list.data.map(item => {
                    const day = parseInt(
                      (this.getTimestamp(item.projectEndTime) -
                        this.getTimestamp(item.projectStartTime)) /
                        86400 /
                        1000
                    )
                    const timeData = this.timeData
                    const upData = timeData.data.up
                    const downData = timeData.data.down
                    const start =
                      (this.getTimestamp(item.projectStartTime) -
                        this.getTimestamp(
                          `${upData.year}/${upData.month}/01 00:00:00`
                        )) /
                      1000 /
                      86400
                    const end =
                      (this.getTimestamp(item.projectEndTime) -
                        this.getTimestamp(
                          `${upData.year}/${upData.month}/01 00:00:00`
                        )) /
                      1000 /
                      86400
                    const startPosition = start
                      ? start > 0
                        ? parseFloat((start / timeData.totalDay).toFixed(2)) *
                          100
                        : 0
                      : start
                    const endPosition = end
                      ? end > 0
                        ? parseFloat((end / timeData.totalDay).toFixed(2)) * 100
                        : 100
                      : end
                    // console.log(`开始位置：${startPosition}结束位置：${parseFloat((endPosition - startPosition).toFixed(2))}---start:${start}---end:${end}`)
                    return Object.assign(item, {
                      day: day,
                      width: parseFloat(
                        (endPosition - startPosition).toFixed(2)
                      ),
                      left: startPosition
                    })
                  })
                : null
            }
          })
          // console.log(res)
        })
      const projectList = [
        {
          name: '留存率',
          data: [
            {
              projectName: '智能分人群运营-尝鲜版面效果改善',
              projectProgress: '开发中·30%',
              projectLeader: '刘鹏',
              projectCost: '60人天',
              projectType: 1,
              projectTarget: 'CTR+10.00% 日均活跃时长+5.00min',
              projectResult: '大数据+需要拼接',
              projectStartTime: '2021-01-05 00:00:00',
              projectEndTime: '2021-01-30 00:00:00'
            },
            {
              projectName: '智能分人群运营-尝鲜版面效果改善',
              projectProgress: '开发中·30%',
              projectLeader: '刘鹏',
              projectCost: '60人天',
              projectType: 4,
              projectTarget: 'CTR+10.00% 日均活跃时长+5.00min',
              projectResult: '大数据+需要拼接',
              projectStartTime: '2020-10-29 00:00:00',
              projectEndTime: '2020-12-30 00:00:00'
            }
          ]
        },
        {
          name: '新增激活量',
          data: [
            {
              projectName: '智能分人群运营-尝鲜版面效果改善',
              projectProgress: '验证中·延期3天',
              projectLeader: '刘鹏',
              projectCost: '60人天',
              projectType: 2,
              projectTarget: 'CTR+10.00% 日均活跃时长+5.00min',
              projectResult: '大数据+需要拼接',
              projectStartTime: '2020-12-01 00:00:00',
              projectEndTime: '2021-02-15 00:00:00'
            }
          ]
        },
        {
          name: '主页周活',
          data: [
            {
              projectName: '智能分人群运营-尝鲜版面效果改善',
              projectProgress: '项目未达标',
              projectLeader: '刘鹏',
              projectCost: '60人天',
              projectType: 3,
              projectTarget: 'CTR+10.00% 日均活跃时长+5.00min',
              projectResult: '大数据+需要拼接',
              projectStartTime: '2020-12-29 00:00:00',
              projectEndTime: '2021-03-15 00:00:00'
            }
          ]
        },
        {
          name: '每周观影时长',
          data: [
            {
              projectName: '智能分人群运营-尝鲜版面效果改善',
              projectProgress: '项目达标',
              projectLeader: '刘鹏',
              projectCost: '60人天',
              projectType: 4,
              projectTarget: 'CTR+10.00% 日均活跃时长+5.00min',
              projectResult: '大数据+需要拼接',
              projectStartTime: '2020-10-29 00:00:00',
              projectEndTime: '2021-02-28 23:59:59'
            }
          ]
        },
        {
          name: '付费转化率',
          data: null
        }
      ]
      // console.log(this.timeData)
      // this.projectLIst =
    },
    getTimestamp (date) {
      return Date.parse(new Date(date))
    }
  },
  created () {
    const curTimeArr = this.$cUtils.format
      .formatDate(new Date(), 'yyyy-MM-dd')
      .split('-')
    const curMonth = parseInt(curTimeArr[1])
    const curDay = parseInt(curTimeArr[2])
    const upMonth = curMonth === 1 ? 12 : curMonth === 12 ? 1 : curMonth - 1
    const downMonth = curMonth === 12 ? 1 : curMonth + 1
    const year = parseInt(curTimeArr[0])
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
    const dayMap = {
      1: 31,
      2: isLeapYear ? 29 : 28,
      3: 31,
      4: 30,
      5: 31,
      6: 30,
      7: 31,
      8: 31,
      9: 10,
      10: 31,
      11: 30,
      12: 31
    }
    const timeMap = {
      up: {
        year: curMonth === 1 ? year - 1 : year,
        month: upMonth < 10 ? `0${upMonth}` : upMonth,
        day: dayMap[upMonth]
      },
      cur: {
        year: year,
        month: curMonth < 10 ? `0${curMonth}` : curMonth,
        day: dayMap[curMonth],
        onDay: curDay < 10 ? `0${curDay}` : curDay
      },
      down: {
        year: curMonth === 12 ? year + 1 : year,
        month: downMonth < 10 ? `0${downMonth}` : downMonth,
        day: dayMap[downMonth]
      }
    }
    const totalDay =
      parseInt(timeMap.cur.day) +
      parseInt(timeMap.up.day) +
      parseInt(timeMap.down.day)
    const curPosition = parseInt(timeMap.up.day) + parseInt(timeMap.cur.onDay)
    this.timeData = {
      data: timeMap,
      totalDay: totalDay,
      curPosition: parseFloat((curPosition / totalDay).toFixed(2)) * 100
    }
    console.log(this.timeData, '///')
    this.getProject()
  }
}
</script>

<style lang="stylus" scoped>
.business-tags
  height 1.5rem
  line-height 1.5rem
  text-align right
  padding 1.5rem 1.75rem 0 0
  span
    background-image repeating-linear-gradient(0deg,rgba(21, 137, 244, 1) 0%,rgba(51, 118, 254, 0) 100%)
    color #fff
    font-size .8rem
    height 1.5rem
    display inline-block
    padding 0 .4rem
    margin-left 1rem
  .span1
    background-image repeating-linear-gradient(0deg,rgba(21, 137, 244, .6) 0%,rgba(51, 118, 254, 0) 100%)
  .span2
    background-image repeating-linear-gradient(0deg,rgba(21, 137, 244, .3) 0%,rgba(51, 118, 254, 0) 100%)
.business-box
  width calc(100% - 1.75rem)
  margin 0 auto
  height 38.4rem
  overflow hidden
  .business-line
    border-bottom 2px solid rgba(255, 255, 255, .1)
    display flex
    .business-lable
      width 2.8rem
      color rgba(255, 255, 255, .6)
      font-size .8rem
      white-space nowrap
      text-align center
      span
        display inline-block
        white-space normal
        vertical-align middle
    .business-lable:before
      height 100%
      display inline-block
      vertical-align middle
      content ''
    .business-item
      flex 1
      padding .8rem 0 0
      .project-item
        border-radius .5rem
        padding .7rem 0 .7rem .5rem
        margin-bottom .8rem
        .line
          line-height 1rem
          white-space nowrap
          .lable
            font-size .6rem
            color rgba(255, 255, 255, .6)
          .value
            font-size .7rem
            color #ffffff
            padding-right 1rem
          .lable1
            font-size .6rem
            color #fff
            background #000
            display inline-block
            padding 0 10px
          .tags
            height 1rem
            line-height 1rem
            font-size .6rem
            color #fff
            display inline-block
            padding 0 .3rem
            border-radius .5rem
            vertical-align middle
            .icon
              width .7rem
              height .7rem
              margin-right .3rem
              vertical-align middle
              display inline-block
              background-size cover
    .project-item--null
      height 5.5rem
.pic-yAxis
  line-height 2.5rem
  width calc(100% - 1.75rem)
  color #ffffff
  font-size .8rem
  position relative
  margin 0 auto
  .pic-yAxis--box
    margin-left 2.8rem
  .curMonth
    position absolute
  .downMonth
    position absolute
    right 0
    padding-right 3rem
.project-item--verification
  background-image repeating-linear-gradient(90deg,rgba(0, 78, 255, 1) 0%,rgba(24, 150, 255, 1) 45%,rgba(0, 78, 255, .8) 45%,rgba(24, 150, 255, .8) 75%,rgba(0, 78, 255, .2) 75%,rgba(24, 150, 255, .2) 100%)
  .tags
    background #034CD7
  .icon
    background-image url('~@/assets/images/verification-icon.png')
.project-item--dev
  background-image repeating-linear-gradient(90deg,rgba(0, 146, 114, 1) 0%,rgba(0, 183, 144, 1) 45%,rgba(0, 146, 114, .8) 45%,rgba(0, 183, 144, .8) 75%,rgba(0, 146, 114, .2) 75%,rgba(0, 183, 144, .2) 100%)
  .tags
    background rgba(0, 79, 64, .3)
  .icon
    background-image url('~@/assets/images/dev-icon.png')
.project-item--success
  background-image repeating-linear-gradient(90deg,rgba(255, 158, 0, 1) 0%,rgba(255, 176, 0, 1) 45%,rgba(255, 158, 0, .8) 45%,rgba(255, 176, 0, .8) 75%,rgba(255, 158, 0, .2) 75%,rgba(255, 176, 0, .2) 100%)
  .tags
    background #F27900
  .icon
    background-image url('~@/assets/images/success-icon.png')
.project-item--fail
  background-image repeating-linear-gradient(90deg,rgba(250, 67, 0, 1) 0%,rgba(253, 127, 0, 1) 45%,rgba(250, 67, 0, 1) 45%,rgba(253, 127, 0, .6) 75%,rgba(250, 67, 0, .2) 75%,rgba(253, 127, 0, .2) 100%)
  .tags
    background #E83F00
  .icon
    background-image url('~@/assets/images/fail-icon.png')
.main-header
  background #1A1939
  height 3.2rem
  display flex
  padding  0 50px
  .header-left
    font-size 1rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
  .header-right
    height 1.6rem
    padding-top 0.8rem
    opacity .4
.table-item
  height 11.75rem
  padding .75rem 1.5rem 0 1.5rem
  .table-head
    margin-bottom .25rem
    border-radius .3rem
    overflow hidden
    display flex
    .head-item
      flex 1
      height 1.5rem
      line-height 1.5rem
      margin 0 1px
      background-image linear-gradient(to right, #005EFF, #1896FF)
      color #ffffff
      font-size .8rem
      text-align center
  .head-item:last-child
    margin-right 0
  .head-item:first-child
    margin-left 0
  .table-body
    border-radius .3rem
    overflow hidden
    .table-line
      display flex
      text-align center
      line-height 2rem
      color rgba(255, 255, 255, .6)
      font-size .7rem
      .body-lable
        flex 1
        overflow hidden
        margin 0 1px
        background #1F1E44
        position relative
      .body-lable:after
        height 1px
        border-bottom 1px solid rgba(255, 255, 255, .1)
        position absolute
        left 0
        bottom 0
        width 100%
        content ''
    .table-line:last-child .body-lable:after
      display none
    .body-lable:last-child
      margin-right 0
    .body-lable:first-child
      margin-left 0
.survey-tips
  font-size .8rem
  color rgba(255, 255, 255, .6)
  line-height 2.3rem
  padding 0 1.5rem
</style>
